// Only what en-GB says differently; every other string is en-US (mergeLocaleResources).
export const workspace = {
  integrationHub: {
    connectedConfigWizard: {
      sourceLead: "Give the source a friendly name your team will recognise. The internal key must be unique; leave it blank to auto-generate.",
    },
    embeddedApps: {
      identityHelp_sso: "People sign in with their organisation's Microsoft account, in the tenant below. Other accounts and other tenants are refused.",
      idpTenantHelp: "The directory (tenant) ID of the organisation. Sign-ins from any other tenant are refused.",
    },
  },
  defaults: {
    openOrganization: "Edit in Organisation profile",
    orgHint: "Defaults are edited in Organisation profile. They use the same supported lists as personal language and timezone settings.",
  },
  overviewScreen: {
    addSummaryHint: "Add a short summary in organisation profile.",
    manageOrgA11y: "Manage organisation profile",
    viewOrgA11y: "View organisation profile",
    manageOrgTitle: "Manage organisation",
    viewOrgTitle: "View organisation",
    itemOrgProfileTitle: "Organisation profile",
  },
  organizationScreen: {
    pageTitle: "Organisation profile",
    memberNotice: "Only workspace owners can edit organisation details and report branding. You can view shared information below.",
    loadingProfile: "Loading organisation profile…",
    organizationSectionTitle: "Organisation",
    summaryPlaceholder: "Short description of your organisation",
    saveOrganization: "Save organisation",
    organizationDetailsSaved: "Organisation details updated.",
  },
  shellTabs: {
    organization: "Organisation",
  },
} as const;
